import { AxiosResponse } from "axios";

import API from "../api";

const ROUTE_NAME = "shipment/subscriber";

const CommunicationShipmentMovingService = {
  async sendSms(body: any): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/send/sms`, body);
  },
  async sendEmail(body: any): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/send/email`, body);
  },
};

export default CommunicationShipmentMovingService;
